import React from "react";
import LandingPage from "../../pages/LandingPage/LandingPage";
function Registration() {
  return <LandingPage />;
}

export default Registration;
